import { usePostApiV1ThreeLetterCodeClientAdminsStressCheckSchedule } from '@fukuri-admins/apis/client/gen/endpoints';

export const usePostStressAssessmentSchedule =
  usePostApiV1ThreeLetterCodeClientAdminsStressCheckSchedule;
